module.exports = __webpack_public_path__ + "img/1-IMG_2612.22097dfe.png";